import { createContext, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import * as React from 'react';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

type State = {
  severity: 'error' | 'warning' | 'info' | 'success';
  open?: boolean;
  message: string;
};

const initialState: State = {
  severity: 'info',
  open: false,
  message: ''
};

export interface SnackBarContextType extends State {
  handleSnackBar: (update: State) => void;
}

export const SnackBarContext = createContext<SnackBarContextType>({
  ...initialState,
  handleSnackBar: () => {}
});

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6}
ref={ref}
variant="filled"
{...props} />;
});

interface SnackbarProviderProps extends React.PropsWithChildren {}

export const SnackbarProvider: React.FC<SnackbarProviderProps> = ({
  children
}) => {
  const [state, setState] = React.useState<State>(initialState);

  const handleClose = (
    _event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setState({ ...state, open: false });
  };

  const handleSnackBar = useCallback((update: State) => {
    setState({ ...update, open: true });
  }, []);

  const action = <Alert severity={state.severity}>{state.message}</Alert>;

  return (
    <SnackBarContext.Provider value={{ ...state, handleSnackBar }}>
      {children}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={state.open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        {action}
      </Snackbar>
    </SnackBarContext.Provider>
  );
};

export const SnackbarConsumer = SnackBarContext.Consumer;
